export const getCompanyDetails = (state) => state.company;
